// extracted by mini-css-extract-plugin
export default {"maskingImageContainer":"freehand-masking-canvas-module__maskingImageContainer--wamqe"};